import { useState } from "react";
import { FiUserPlus } from "react-icons/fi";
import { handleEmployeeInsert } from "../services/api";
import { Input, Modal } from "@iq/models";

const requiredMarkStyle = { color: "var(--color-danger)", marginLeft: "2px" };

function InsertEmployeeModal({ onClose, onInserted }) {
    const [form, setForm] = useState({
        name: "",
        email: "",
        role: "",
    });
    const [submitting, setSubmitting] = useState(false);
    const [submitError, setSubmitError] = useState("");

    const isFormValid = Boolean(form.name.trim() && form.email.trim());

    function handleFieldChange(event) {
        const { name, value } = event.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    }

    async function handleSubmit(event) {
        event?.preventDefault?.();
        if (!isFormValid) {
            return;
        }
        setSubmitError("");
        setSubmitting(true);

        try {
            await handleEmployeeInsert({
                name: form.name.trim(),
                email: form.email.trim(),
                role: form.role.trim(),
            });

            await onInserted?.();
            onClose?.();
        } catch (error) {
            setSubmitError(error?.message || "Failed to insert employee");
        } finally {
            setSubmitting(false);
        }
    }

    const labelStyle = {
        fontSize: "var(--font-size-xs)",
        fontWeight: 600,
        color: "var(--color-fg-muted)",
        marginBottom: "4px",
        display: "block",
    };

    return (
        <Modal
            isOpen
            onClose={onClose}
            title="Add Employee"
            icon={<FiUserPlus size={32} />}
            shrink
            errorMessage={submitError}
            actionButtons={[
                {
                    key: "submit",
                    text: submitting ? "Saving..." : "Add +",
                    color: "accent",
                    disabled: submitting || !isFormValid,
                    onClick: handleSubmit,
                },
            ]}
        >
            <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "var(--space-3)", width: "100%" }}>
                <div>
                    <label style={labelStyle} htmlFor="name">
                        Name<span style={requiredMarkStyle}>*</span>
                    </label>
                    <Input
                        id="name"
                        name="name"
                        type="text"
                        colorScheme="dark"
                        value={form.name}
                        onChange={handleFieldChange}
                        placeholder="e.g. Jane Smith"
                    />
                </div>

                <div>
                    <label style={labelStyle} htmlFor="email">
                        Email<span style={requiredMarkStyle}>*</span>
                    </label>
                    <Input
                        id="email"
                        name="email"
                        type="email"
                        colorScheme="dark"
                        value={form.email}
                        onChange={handleFieldChange}
                        placeholder="e.g. jane.smith@acmecorp.com"
                    />
                </div>

                <div>
                    <label style={labelStyle} htmlFor="role">Role</label>
                    <Input
                        id="role"
                        name="role"
                        type="text"
                        colorScheme="dark"
                        value={form.role}
                        onChange={handleFieldChange}
                        placeholder="e.g. Software Engineer"
                    />
                </div>
            </form>
        </Modal>
    );
}

export default InsertEmployeeModal;
